// removed by extract-text-webpack-plugin
module.exports = {"hidden":"_3Zats","visuallyhidden":"_3UI81","hide-text":"_5t536","center":"_2y8QW","noprint":"xHhP9","root":"_2ftn2"};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/cn-skin-core/styles/svg/ChevronLeft.scss
 ** module id = 930
 ** module chunks = 1
 **/